import { render, staticRenderFns } from "./ModalSair.vue?vue&type=template&id=3e39f710"
import script from "./ModalSair.vue?vue&type=script&lang=js"
export * from "./ModalSair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports